import {useLocation} from 'react-router-dom';
import useUser from '../../hooks/useUser';
import './Footer.scss';
import rolesConst from '@/constants/rolesConst';
import routesConst from '@/constants/routesConst';

export default function Footer() {
  const {user} = useUser();
  const isApplicant = user?.role === rolesConst.applicant;
  const location = useLocation();
  const isOnClausesPage = location.pathname === routesConst.clausesAcceptance;

  return (
    <footer className="footer">
      <div className="d-flex align-items-center footer-inner">
        <div className="column">
          <h5 className="mb-0">Ethics Data Analytics © 2024</h5>
          <span>Todos los derechos reservados</span>
        </div>
        {isApplicant && !isOnClausesPage && (
          <div className="footer-links">
            <a
              href="https://ethicsdataanalytics.com/#/Privacy"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bi bi-shield-check"></i>Aviso de Privacidad
            </a>
            <span className="separator"> | </span>
            <a
              href="https://ethicsdataanalytics.com/#/Terms"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bi bi-file-earmark-text"></i>Términos y Condiciones
            </a>
                <span className="separator"> | </span>
                <a
                  href="https://ethicsdataanalytics.com/#/StmtOfTruth"
                  target="_blank"
                  rel="noreferrer"
                >
                <i className="bi bi-check-circle"></i>Declaración de Veracidad
            </a>
          </div>
        )}
      </div>
    </footer>
  );
}
